import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dedicated-database',
  templateUrl: './dedicated-database.component.html',
  styleUrls: ['./dedicated-database.component.scss']
})
export class DedicatedDatabaseComponent implements OnInit {

  constructor() { }
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'dedicated-database'; 
  title: string = 'Consulta nuestros precios sin compromiso, Contáctanos.'; 

  ngOnInit(): void {
  }

}
